<template>

    <div>
        <div id="page">
            <Header></Header>
<!--        <div class="ban-hd"><img src="" alt=""></div>-->
        <div class="formw01 wp">
            <div class="infow01-val">
                <div class="formw01-item">
                    <div class="formw01-lab">发布人<i class="strongTip">*</i></div>
                    <div class="formw01-val">
                        <label class="radio-label" v-for="item in faburenTypeList">
                            <input type="radio" name="faburen" :checked="faburenType == item.type" @click="faburenType = item.type">
                            <span class="con">{{ item.name }}</span>
                        </label>
                    </div>
                </div>
            </div>
            <hr class="g-hr">
            <div class="infow01-val">
                <div class="formw01-item">
                    <div class="formw01-lab">委托目标<i class="strongTip">*</i></div>
                    <div class="formw01-val">
                        <select class="formw01-sel s1" name="target" @change="selectVal">
                            <option value="-1" selected>请选择</option>
                            <option :value="item.type" v-for="(item, index) in targetList">{{ item.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="formw01-item">
                    <div class="formw01-lab">委托面积<i class="strongTip">*</i></div>
                    <div class="formw01-val">
                        <input class="formw01-inp s1" type="number" v-model="area_mix">
                        <span>至</span>
                        <input class="formw01-inp s1" type="number" v-model="area_max">
                        <span>㎡</span>
                    </div>
                </div>
                <div class="formw01-item">
                    <div class="formw01-lab">预算金额<i class="strongTip">*</i></div>
                    <div class="formw01-val">
                        <select class="formw01-sel" name="type" @change="selectVal">
                            <option value="-1" selected hidden>委托类型</option>
                            <option :value="item.type" v-for="(item, index) in typeList">{{ item.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="formw01-item">
                    <div class="formw01-lab"></div>
                    <div class="formw01-val">
                        <input class="formw01-inp s1" type="number" v-model="budget_mix">
                        <span>至</span>
                        <input class="formw01-inp s1" type="number" v-model="budget_max">
                        <select class="formw01-sel s2" name="budgetUnit" @change="selectVal">
                            <option value="-1" selected hidden>单位</option>
                            <option :value="item.type" v-for="item in budgetUnitList">{{ item.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="formw01-item">
                    <div class="formw01-lab valign-top">其他要求</div>
                    <div class="formw01-val">
                        <textarea class="formw01-area" placeholder="其他要求" v-model="detail"></textarea>
                    </div>
                </div>
            </div>
            <hr class="g-hr">
            <div class="infow01-val">
                <div class="formw01-item">
                    <div class="formw01-lab">姓名<i class="strongTip">*</i></div>
                    <div class="formw01-val">
                        <div class="codebar">
                            <input class="formw01-inp" type="text" placeholder="输入真实姓名" v-model="bider_name">
                        </div>
                    </div>
                </div>
                <div class="formw01-item">
                    <div class="formw01-lab">手机<i class="strongTip">*</i></div>
                    <div class="formw01-val">
                        <div class="codebar">
                            {{ tel }}
<!--                            <input class="formw01-inp" type="text" placeholder="输入11位手机号码">-->
<!--                            <input class="btn" type="button" value="获取验证码" @click="getCode">-->
                        </div>
                    </div>
                </div>
                <!--<div class="formw01-item">
                    <div class="formw01-lab"></div>
                    <div class="formw01-val">
                        <input class="formw01-inp s1" type="text" v-model="code" placeholder="输入动态验证码">
                    </div>
                </div>-->
            </div>
            <div class="formw01-item-ft">
                <div class="btn s1" @click="resetEdit">取　消</div>
                <div class="btn s2" @click="Certified">提　交</div>
            </div>
        </div>
        </div>
        <Footer></Footer>
    </div>

</template>

<script>


    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { Toast } from 'vant'

    export default {
        name: "PublishCommission",
        data () {
            return {
                faburenTypeList: [
                    {
                        type: 'qiye',
                        name: '企业'
                    }, {
                        type: 'dailiren',
                        name: '代理人'
                    }, {
                        type: 'geren',
                        name: '个人'
                    }],
                targetList: [
                    {
                        type: 'chanyeyuan',
                        name: '产业园'
                    }, {
                        type: 'xiezilou',
                        name: '写字楼'
                    }, {
                        type: 'tudi',
                        name: '土地'
                    }, {
                        type: 'changfang',
                        name: '厂房'
                    }, {
                        type: 'shangpu',
                        name: '商铺'
                    }
                ],
                typeList: [
                    {
                        type: 'lease',
                        name: '租贷'
                    }, {
                        type: 'buy',
                        name: '购买'
                    }
                ],
                budgetUnitList: [
                    {
                        type: 'day',
                        name: '元/天'
                    }, {
                        type: 'month',
                        name: '元/月'
                    }, {
                        type: 'quarter',
                        name: '元/季度'
                    }, {
                        type: 'year',
                        name: '元/年'
                    }, {
                        type: 'buy',
                        name: '元'
                    },
                ],
                faburenType: '',
                target: '',
                type: '',
                budgetUnit: '',
                area_mix: '',
                area_max: '',
                budget_mix: '',
                budget_max: '',
                bider_name: '',
                detail: '',
                tel: ''
            }
        },
        components: {
            Header, Footer,
            [Toast.name]: Toast
        },
        mounted() {
            this.checkLogined();
        },
        methods: {
            checkLogined () {
                var _this = this;
                _this.api.getUserInfo().then(function(response){
                    _this.tel = response.member_info.mobile
                })
            },
            selectVal(el){
                console.log(el)
                this[el.target.name] = el.target.value
            },
            resetEdit(){
                this.faburenType = 0;
                this.target = '';
                this.type = '';
                this.budgetUnit = '';
                this.area_mix = '';
                this.area_max = '';
                this.budget_mix = '';
                this.budget_max = '';
                this.bider_name = '';
                this.detail = ''
            },
            Certified(){
                const _this = this;
                let params = new FormData();
                params.append('faburen_type', _this.faburenType);
                params.append('target', _this.target);
                params.append('area_mix', _this.area_mix);
                params.append('area_max', _this.area_max);
                params.append('type', _this.type);
                params.append('budget_unit', _this.budgetUnit);
                params.append('budget_mix', _this.budget_mix);
                params.append('budget_max', _this.budget_max);
                params.append('bider_name', _this.bider_name);
                params.append('detail', _this.detail);
                params.append('bider_phone', _this.tel);
                _this.api.addEntrust(params).then(function(response){
                    Toast(response.msg);
                    if (response.status==1) {
                        _this.$router.back();
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .ban-hd {margin: .3rem;background-color: #ddd;height: 3.45rem;overflow: hidden;}
    .ban-hd img {display: block;width: 100%;height: 100%;}
    .radio-label {float: left;position: relative;margin-right: .5rem;}
    .radio-label input {position: absolute;top: 0;left: 0;width: 0;height: 0;opacity: 0;visibility: hidden;}
    .radio-label .con {padding-left: .36rem;position: relative;}
    .radio-label .con:before {content: '';position: absolute;left: 0;top: 50%;margin-top: -.1rem;width: .2rem;height: .2rem;-webkit-border-radius: 50%;-moz-border-radius: 50%;border-radius: 50%;border: 2px solid #898989;}
    .radio-label input:checked + .con:before {background-color: #24b5fe;border-color: #24b5fe;}
    .g-hr {display: block;height: 1px;background-color: #898989;margin: 0;}
    .formw01-val span {width: 2em;text-align: center;}
    .formw01-inp.s1 {width: 2rem;}
    /deep/ .formw01 {overflow: hidden;min-height: calc(100vh - 2.84rem);}
</style>